import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface SkillCollectionSplitPaneProps {
  sidebar: ReactNode;
  children: ReactNode;
  className?: string;
}

export const SkillCollectionSplitPane = ({
  sidebar,
  children,
  className,
}: SkillCollectionSplitPaneProps) => (
  <div
    className={cn(
      "flex h-full min-h-0 flex-1 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm shadow-gray-950/5",
      className,
    )}
  >
    {sidebar}
    <div className="flex min-h-0 min-w-0 flex-1 flex-col bg-white">{children}</div>
  </div>
);
